module.exports = __webpack_public_path__ + "static/media/solution-selection@3x.8052ed96.png";